/**
 * Phase 1 UI scope: authentication, user management, animals, treatments,
 * medicines, and stock taking (herd attendance). Other modules stay in the
 * codebase but are hidden from nav and redirect if hit directly.
 */

import { APP_HOME_PATH } from "./routes";

const PHASE1_DISABLED_PREFIXES = [
  "/income",
  "/expenses",
  "/calves",
  "/planning",
  "/reports",
];

/**
 * @param {string} path
 * @returns {string}
 */
export function normalizeAppPath(path) {
  if (!path || path === "/") return "/";
  const s = path.startsWith("/") ? path : `/${path}`;
  const base = s.split("?")[0];
  if (base.length > 1 && base.endsWith("/")) {
    return base.slice(0, -1);
  }
  return base;
}

/**
 * True if this pathname is not part of Phase 1 (should redirect / hide in nav).
 * @param {string} path
 */
export function isPhase1PathDisabled(path) {
  const base = normalizeAppPath(path);
  if (
    base === "/planning/activities" ||
    base.startsWith("/planning/activities/")
  ) {
    return false;
  }
  return PHASE1_DISABLED_PREFIXES.some(
    (pre) => base === pre || base.startsWith(`${pre}/`)
  );
}

/**
 * Sidebar NavLink targets shown in Phase 1.
 * @param {string} to
 */
export function isPhase1SidebarNavEnabled(to) {
  if (!to) return false;
  const p = normalizeAppPath(to);
  const allowed = new Set([
    APP_HOME_PATH,
    "/animals",
    "/treatments",
    "/medicines",
    "/milking",
    "/stock-taking",
    "/admin/users",
  ]);
  return allowed.has(p);
}

/**
 * Home cards, quick actions, etc.: show link if destination is in scope.
 * @param {string} path
 */
export function isPhase1DestinationEnabled(path) {
  return !isPhase1PathDisabled(path);
}

export { PHASE1_DISABLED_PREFIXES };
